module.exports = __webpack_public_path__ + "img/webinar_icon.2627a789.png";